import { SLIDER_VARIANT } from '../../constants/uiConfig'
import SliderV2 from './SliderV2'
import SliderV1 from './SliderV1'

const Slider = (props) => {
  const variant = props.variant || SLIDER_VARIANT.V1

  if (variant === SLIDER_VARIANT.V2) {
    return <SliderV2 {...props} />
  }
  return <SliderV1 {...props} />
}

export default Slider
